// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * ALMA Chatbot API
 * API to manage Alma chatbot interactions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MainAskRequest
 */
export interface MainAskRequest {
  /**
   *
   * @type {number}
   * @memberof MainAskRequest
   */
  conversationId?: number;
  /**
   * required
   * @type {string}
   * @memberof MainAskRequest
   */
  message?: string;
  /**
   * optional, text extracted from current page DOM
   * @type {string}
   * @memberof MainAskRequest
   */
  pageContext?: string;
}

/**
 * Check if a given object implements the MainAskRequest interface.
 */
export function instanceOfMainAskRequest(
  value: object,
): value is MainAskRequest {
  return true;
}

export function MainAskRequestFromJSON(json: any): MainAskRequest {
  return MainAskRequestFromJSONTyped(json, false);
}

export function MainAskRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainAskRequest {
  if (json == null) {
    return json;
  }
  return {
    conversationId:
      json['conversation_id'] == null ? undefined : json['conversation_id'],
    message: json['message'] == null ? undefined : json['message'],
    pageContext:
      json['page_context'] == null ? undefined : json['page_context'],
  };
}

export function MainAskRequestToJSON(json: any): MainAskRequest {
  return MainAskRequestToJSONTyped(json, false);
}

export function MainAskRequestToJSONTyped(
  value?: MainAskRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    conversation_id: value['conversationId'],
    message: value['message'],
    page_context: value['pageContext'],
  };
}
